// notificationApi.js
import api from './api'; // Import your base API instance

const NotificationApi = {
  // GET notifications for a sub-user.
  all: (userId, subUserId) =>
    api.get(`notification/subUser/${userId}/${subUserId}`),

  // GET a specific notification by id.
  get: (id) =>
    api.get(`notification/${id}`),

  // POST for QR code scan; expects a request body (qrCodeRequest).
  qrScan: (qrCodeRequest) =>
    api.post('notification/qr-scan', qrCodeRequest),
};

export default NotificationApi;
